export function maskMobile(value) {
  if (!value) return '-'
  const mobile = String(value)
  if (mobile.length < 7) return mobile
  return `${mobile.slice(0, 3)}****${mobile.slice(-4)}`
}

export const MEMBERSHIP_LEVEL_LABELS = {
  0: '普通用户',
  1: '核心用户',
  2: '联合发起人'
}

export function membershipLevelLabel(level, fallback = '普通用户') {
  const key = Number(level || 0)
  return MEMBERSHIP_LEVEL_LABELS[key] || fallback
}

import { API_BASE_URL } from './request'

const IMAGE_EXT_RE = /\.(png|jpe?g|gif|webp|bmp|heic|heif)(\?.*)?$/i
const VIDEO_EXT_RE = /\.(mp4|mov|webm|m4v|avi|3gp)(\?.*)?$/i
const IMAGE_TYPE_VALUES = [1, 2, 5]
const VIDEO_TYPE_VALUES = [3, 4]

const INTERNAL_MEDIA_HOST_RE = /^(https?:)?\/\/(127\.0\.0\.1|localhost|api\.cdz7\.cn|cdz7s2\.yunfanruanjian\.com|\d+\.\d+\.\d+\.\d+)(:\d+)?/i

function withApiBaseUrl(path) {
  if (!API_BASE_URL || API_BASE_URL === '/') return path
  return `${API_BASE_URL.replace(/\/+$/, '')}${path.startsWith('/') ? path : `/${path}`}`
}

function extractUploadResourcePath(value) {
  let url = String(value || '').trim()
  if (!url) return null

  if (/^(https?:)?\/\//i.test(url)) {
    try {
      const parsed = new URL(url, 'https://placeholder.local')
      const pathWithSuffix = `${parsed.pathname}${parsed.search}${parsed.hash}`
      if (/^\/uploads\//i.test(parsed.pathname) || /^\/api\/common\/file\//i.test(parsed.pathname)) {
        url = pathWithSuffix
      } else {
        return null
      }
    } catch (e) {
      return null
    }
  }

  if (/^\/api\/common\/file\//i.test(url)) {
    return url.replace(/^\/api\/common\/file\/?/i, '')
  }
  if (/^\/uploads\//i.test(url)) {
    return url.replace(/^\/uploads\/?/i, '')
  }
  if (/^uploads\//i.test(url)) {
    return url.replace(/^uploads\/?/i, '')
  }
  if (url.startsWith('/')) {
    return url.replace(/^\//, '')
  }
  if (/^[^/\\]+\.[a-z0-9]+(\?.*)?$/i.test(url)) {
    return url
  }
  return null
}

function buildUploadResourceUrl(uploadPath) {
  const suffixIndex = uploadPath.search(/[?#]/)
  const filePath = suffixIndex >= 0 ? uploadPath.slice(0, suffixIndex) : uploadPath
  const suffix = suffixIndex >= 0 ? uploadPath.slice(suffixIndex) : ''
  const encodedPath = filePath.split('/').filter(Boolean).map(encodeURIComponent).join('/')
  if (!encodedPath) return ''
  return `${withApiBaseUrl(`/uploads/${encodedPath}`)}${suffix}`
}

function resolveUploadResource(value) {
  const uploadPath = extractUploadResourcePath(value)
  if (uploadPath === null) return ''
  return buildUploadResourceUrl(uploadPath)
}

function isExternalMediaUrl(url) {
  if (!/^(https?:)?\/\//i.test(url)) return false
  return !INTERNAL_MEDIA_HOST_RE.test(url)
}

function getMediaUrl(item) {
  if (!item) return ''
  return item.mediaUrl || item.url || item.imageUrl || item.videoUrl || item.logoUrl || ''
}

function getMediaTypeNumber(item) {
  if (!item || item.mediaType === undefined || item.mediaType === null || item.mediaType === '') return null
  const mediaType = Number(item.mediaType)
  return Number.isNaN(mediaType) ? null : mediaType
}

function getMediaTypeText(item) {
  if (!item || item.mediaType === undefined || item.mediaType === null) return ''
  return String(item.mediaType).trim().toLowerCase()
}

function isTypedImage(item) {
  const mediaType = getMediaTypeNumber(item)
  const mediaTypeText = getMediaTypeText(item)
  return IMAGE_TYPE_VALUES.includes(mediaType) || ['image', 'photo', 'picture'].includes(mediaTypeText)
}

function isTypedVideo(item) {
  const mediaType = getMediaTypeNumber(item)
  const mediaTypeText = getMediaTypeText(item)
  return VIDEO_TYPE_VALUES.includes(mediaType) || mediaTypeText === 'video'
}

export function resolveMediaUrl(value) {
  if (!value) return ''
  const url = String(value).trim()
  if (!url) return ''
  if (/^(data|blob):/i.test(url)) return url

  const uploadResourceUrl = resolveUploadResource(url)
  if (uploadResourceUrl) return uploadResourceUrl

  if (isExternalMediaUrl(url)) return url

  return withApiBaseUrl(url.startsWith('/') ? url : `/${url}`)
}

export function normalizeMediaItem(item) {
  if (!item) return null
  const mediaUrl = resolveMediaUrl(getMediaUrl(item))
  if (!mediaUrl) return null
  return {
    ...item,
    mediaUrl,
    coverUrl: resolveMediaUrl(item.coverUrl || item.posterUrl || item.thumbnailUrl || '')
  }
}

export function isImageMedia(item) {
  const mediaUrl = getMediaUrl(item)
  if (!mediaUrl) return false
  if (IMAGE_EXT_RE.test(mediaUrl)) return true
  if (VIDEO_EXT_RE.test(mediaUrl)) return false
  return isTypedImage(item)
}

export function isVideoMedia(item) {
  const mediaUrl = getMediaUrl(item)
  if (!mediaUrl) return false
  if (VIDEO_EXT_RE.test(mediaUrl)) return true
  if (IMAGE_EXT_RE.test(mediaUrl)) return false
  return isTypedVideo(item)
}
